import { gsap, Back, Power2, Power4, ScrollTrigger } from "gsap/dist/all";

gsap.registerPlugin(Back, Power2, Power4, ScrollTrigger);

$(function () {
  const historyEle = ".js-history-top";
  if ($(historyEle).length) {
    $(historyEle).addClass("is-show");
    fadeIn();
    gsapAnimation();
  }
});

//==========
//gsap フェードインアニメーション
//==========
function fadeIn() {
  var animationDuration = 0.35;
  var animationEase = Power2.easeOut;
  //下からフェードイン
  gsap.utils.toArray(".js-fade-in").forEach((el) => {
    gsap.from(el, {
      y: 100,
      opacity: 0,
      duration: animationDuration,
      ease: animationEase,
      scrollTrigger: {
        start: "top 80%",
        trigger: el
      }
    });
  });

  //左からフェードイン
  gsap.utils.toArray(".js-fade-in-left").forEach((el) => {
    gsap.from(el, {
      x: -100,
      opacity: 0,
      duration: animationDuration,
      ease: animationEase,
      scrollTrigger: {
        start: "top 80%",
        trigger: el
      }
    });
  });

  //右からフェードイン
  gsap.utils.toArray(".js-fade-in-right").forEach((el) => {
    gsap.from(el, {
      x: 100,
      opacity: 0,
      duration: animationDuration,
      ease: animationEase,
      scrollTrigger: {
        start: "top 80%",
        trigger: el
      }
    });
  });

  //左から順に下からフェードイン
  gsap.set(".js-fade-in-list", {
    y: 100,
    opacity: 0
  });

  ScrollTrigger.batch(".js-fade-in-list", {
    batchMax: 3,
    onEnter: (batch) =>
      gsap.to(batch, {
        y: 0,
        opacity: 1,
        duration: animationDuration,
        ease: animationEase,
        stagger: {
          each: 0.3,
          from: "start"
        }
      }),
    start: "top 80%"
  });
}

function gsapAnimation() {
  //スタートアイコン
  gsap.from(".js-start-icon", {
    y: -10,
    x: -10,
    repeat: -1,
    duration: 0.8,
    yoyo: true,
    ease: Power4.easeOut
  });

  //写真風画像 貼り付け
  gsap.utils.toArray(".js-photo-image").forEach((el) => {
    gsap.from(el, {
      y: -50,
      opacity: 0,
      scale: 1.2,
      duration: 0.6,
      ease: Back.easeOut,
      scrollTrigger: {
        start: "top 50%",
        trigger: el
      }
    });
  });

  //写真風画像 ピン留め
  gsap.utils.toArray(".js-photo-pin").forEach((el) => {
    gsap.from(el, {
      y: -20,
      opacity: 0,
      duration: 0.25,
      delay: 0.4,
      ease: Back.easeOut,
      scrollTrigger: {
        start: "top 55%",
        trigger: el
      }
    });
  });

  //スト2キャラクター
  gsap.from(".js-character-sf2", {
    opacity: 0,
    rotate: 20,
    y: 50,
    duration: 0.8,
    ease: Back.easeOut,
    scrollTrigger: {
      start: "top 60%",
      trigger: ".js-character-sf2"
    }
  });

  //バイオキャラクター
  gsap.fromTo(
    ".js-character-bio",
    {
      opacity: 0,
      rotate: -30,
      x: -50
    },
    {
      opacity: 1,
      rotate: 0,
      x: 0,
      duration: 1,
      ease: Back.easeOut,
      scrollTrigger: {
        start: "top 60%",
        trigger: ".js-character-bio"
      }
    }
  );

  //2004年 モンハンキャラクター
  gsap.from(".js-character-mh-2004", {
    opacity: 0,
    y: -100,
    scale: 1.5,
    duration: 0.8,
    ease: Back.easeOut,
    scrollTrigger: {
      start: "top 40%",
      trigger: ".js-character-mh-2004"
    }
  });

  //デビルメイクライキャラクター
  gsap.from(".js-character-dmc", {
    opacity: 0,
    x: 100,
    duration: 0.8,
    ease: Power4.easeOut,
    scrollTrigger: {
      start: "top 60%",
      trigger: ".js-character-dmc"
    }
  });

  //ドラゴンズドグマキャラクター
  gsap.from(".js-character-dd", {
    opacity: 0,
    x: 100,
    duration: 1,
    ease: Power4.easeOut,
    scrollTrigger: {
      start: "top 60%",
      trigger: ".js-character-dd"
    }
  });

  //2018年 モンハンキャラクター
  gsap.from(".js-character-mh-2018", {
    opacity: 0,
    y: -100,
    x: -100,
    scale: 1.2,
    duration: 0.8,
    yoyo: true,
    ease: Back.easeOut,
    scrollTrigger: {
      start: "top 50%",
      trigger: ".js-character-mh-2018"
    }
  });

  //異議あり！アイコン
  gsap.from(".js-igiari", {
    opacity: 0,
    scale: 1.5,
    y: 100,
    duration: 0.35,
    ease: Back.easeOut,
    scrollTrigger: {
      start: "top 80%",
      trigger: ".js-igiari"
    }
  });

  //ワンタメ画像
  gsap.from(".js-image-wantame", {
    opacity: 0,
    x: 100,
    duration: 0.6,
    ease: Power4.easeOut,
    scrollTrigger: {
      start: "top 60%",
      trigger: ".js-image-wantame"
    }
  });
}
